import { realtimeStatusUpdate } from '../actions';
import { ConnectionStatus } from '../model/realtime.model';
import { createReducer, on } from '@ngrx/store';

export const realtimeFeatureKey = 'realtime';

export interface State {
  lastPing: Date;
  status: ConnectionStatus;
}

export const initialState: State = {
  lastPing: new Date(),
  status: ConnectionStatus.DISCONNECTED,
};

export const reducer = createReducer(
  initialState,
  on(realtimeStatusUpdate, (state, { status }) => ({
    ...state,
    status,
    lastPing: new Date(),
  })),
);

export const getStatus = (state: State) => state.status;
